import Api from "../axios"

export const postReadNotice= async ({id})=>{
    return await Api.post('/read_notice',{
        policyId: id
    })
} 